import permissions from "app/permissions";
import { HEALTHCARE_CAMPAIGNS_APPLICATIONS_DETAILS, SpecialistServicePath } from "utils/constants";
import ShowHealthcareCampaignApplication from "./Show";

export const resources = {
  isMenu: false,
  name: SpecialistServicePath + HEALTHCARE_CAMPAIGNS_APPLICATIONS_DETAILS,
  custom: <ShowHealthcareCampaignApplication />,
  permission: permissions.canPreviewHealthcareCampaignApplications,
};
